<div class="title-bar" [class.small]="!isLargeContainer()">
  <h4>Afbeeldingen vergelijken</h4>

  <ion-button
    color="medium"
    fill="clear"
    size="small"
    class="btn-close"
    (click)="dismiss()"
  >
    <ion-icon name="close" slot="icon-only" />
  </ion-button>
</div>

<div
  #imageViewContainer
  class="images-outer-container"
  [class.small]="!isLargeContainer()"
>
  <!-- Check specifically on undefined, so the correct view is loaded directly
  instead of changing on page load. -->
  @if (isLargeContainer() !== undefined) {
    <div class="images-inner-container">
      @for (
        url of displayedImageUrls();
        track url;
        let index = $index;
        let first = $first;
        let last = $last
      ) {
        <div class="image-container">
          <lib-pinch-zoom backgroundColor="rgba(0, 0, 0, 0.05)" [limitZoom]="5">
            <img [src]="url" [alt]="'Afbeelding ' + index" />
          </lib-pinch-zoom>
          @if (displayedImageUrls().length > 2) {
            <div class="button-container">
              <ion-button
                (click)="remove(url)"
                class="remove-image"
                color="medium"
                fill="clear"
                size="small"
              >
                Verwijder uit vergelijking
              </ion-button>
            </div>
          } @else {
            @if (isLargeContainer() || (!isLargeContainer() && last)) {
              <div class="button-container">
                @if ((first && isLargeContainer()) || !isLargeContainer()) {
                  <ion-button
                    (click)="showAll()"
                    class="show-all-images"
                    color="medium"
                    fill="clear"
                    size="small"
                  >
                    Alle afbeeldingen tonen
                  </ion-button>
                }
              </div>
            }
          }
        </div>
      }
    </div>
  } @else {
    <div class="loader">
      <ion-spinner name="crescent" color="primary" />
    </div>
  }
</div>
